const parseBoolean = (str = '') => str.toLowerCase() === 'true';

// Environment
export const ENABLE_MOCKS = parseBoolean(process.env.REACT_APP_ENABLE_MOCKS);

export const IS_TEST = parseBoolean(process.env.REACT_APP_IS_TEST);

export const GRAPHQL_SCHEMA_PACKAGE =
  process.env.REACT_APP_GRAPHQL_SCHEMA_PACKAGE;

export const GRAPHQL_MOCK_SCENARIO =
  process.env.REACT_APP_MOCK_SCENARIO ?? 'default';

export const MOCK_AUTH = parseBoolean(process.env.REACT_APP_MOCK_AUTH);

export const MOCK_USERID = process.env.REACT_APP_MOCK_USERID ?? 'VXNlcjox'; // default to User:1

export const MOCK_TRUSTED_NODES =
  process.env.REACT_APP_MOCK_TRUSTED_NODES ??
  '[{"id":"UGFydG5lckFjY291bnQ6MQ==", "role":["OWNER", "COMPANY_ADMIN"]}]'; // default to [PartnerAccount:1] with roles

export const MOCK_PORTAL_ADMIN = parseBoolean(
  process.env.REACT_APP_MOCK_PORTAL_ADMIN
);

const config = {
  //Auth0
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || '',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || '',
  connection:
    process.env.REACT_APP_AUTH0_CONNECTION ||
    'Username-Password-Authentication',
  domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
  namespace: `${process.env.REACT_APP_AUTH0_DOMAIN}/`,
  scope: 'openid profile email',
};

// Relay
export const USE_PERSISTED_QUERIES = parseBoolean(
  process.env.REACT_APP_USE_PERSISTED_QUERIES
);
export const PERSISTED_QUERIES_APP_NAME =
  process.env.REACT_APP_PERSISTED_QUERIES_APP_NAME || '';
export const PERSISTED_QUERIES_APP_VERSION =
  process.env.REACT_APP_PERSISTED_QUERIES_APP_VERSION || '';

export const GATEWAY_URL =
  process.env.REACT_APP_GATEWAY_URL || '/gateway/graphql';

export const APOLLO_CLIENT_NAME =
  process.env.REACT_APP_APOLLO_CLIENT_NAME || '';

export const REQUESTACCESS_FLAG = parseBoolean(
  process.env.REACT_APP_FEATURE_REQUESTACCESS
);

// Sentry
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'development';
export const SENTRY_SAMPLE_RATE = parseFloat(
  process.env.REACT_APP_SENTRY_SAMPLE_RATE || '0.2'
);

export default config;
